import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '../auth/session';
import { OperationsPage } from '../pages/operations/operations-page';

export const Route = createFileRoute('/operations')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: OperationsPage,
});
